import { USER_DELETE, USER_DELETE_SUCCESS, USER_DELETE_FAILURE } from './const'
import createMiddleware from 'Reducers/createMiddleware'
import { deleteUser } from '../../Module/graphQL'

export const deleteUserMiddleware = createMiddleware({
  actions: [USER_DELETE, USER_DELETE_SUCCESS, USER_DELETE_FAILURE],
  fetchMethod: (authToken, { userId }) => deleteUser(authToken, userId),
  isOptimistic: true,
})
